export function footer() {

    var allPanels = $('.sub-menu');
    var allAccordions = $('.footer .menu-item-has-children');

    if ($(window).width() < 1200) {
        $('.footer .menu-item-has-children > a').click(function (e) {
            e.preventDefault();
            if ( !$(this).parent().hasClass('active') ) {
                allAccordions.removeClass("active");
                allPanels.slideUp();
                $(this).next().slideDown();
                $(this).parent().addClass('active');
                return false;
            } else {
                $(this).parent().removeClass('active');
                $(this).next().slideUp();
            }
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/footer.js